import React from 'react'
import { GoGoal } from "react-icons/go";

const Goals = () => {
  return (
    <div>

        <div className='flex items-center flex-col justify-center h-screen'>
        <GoGoal className='text-9xl'/>
        <h1>See you soon</h1> 
        </div>
       

    </div>
  )
}

export default Goals